// Template Generated by DataExtraction.py at 1716507313

import DRChecklistEn1 from "../../Forms/DR Checklist/DRChecklist_En1.png";
import DRChecklistEn1Labels from "../../Labels/DR Checklist/DRChecklist_En1.json";
import DRChecklistFr1 from "../../Forms/DR Checklist/DRChecklist_Fr1.png";
import DRChecklistFr1Labels from "../../Labels/DR Checklist/DRChecklist_Fr1.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    fillCheckboxAtLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY,
    signatureLabel,
    signatureTab, checkBoxCharacterSize
} from "../../PDFGenerationUtils";
import { POSSIBLE_SIGNERS } from "../../../Utils/PlanUtils";

import moment from "moment/moment";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {

    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? DRChecklistFr1Labels : DRChecklistEn1Labels;
    const formImage = isFrench ? DRChecklistFr1 : DRChecklistEn1;

    function fillCheckbox(value, label) {
        fillCheckboxAtLabel(doc, value, label, labels);
    }

    function drawText(value, label) {
        drawTextOnLabel(doc, value, label, labels);
    }
    const nowDate = moment(new Date()).format("YYYY-MM-DD");

    let subNames = data.subscriber.firstName + " " + data.subscriber.lastName;
    if (data.common.subscriber2Include) {
        subNames += " and " + data.jointSubscriber.firstName + " " + data.jointSubscriber.lastName;
    }

    // add image
    doc.addImage(formImage, standardFormFormat, labels["image"]["x"], labels["image"]["y"], labels["image"]["width"], labels["image"]["height"], null, standardFormCompression);

    drawText(subNames, 'subNames');

    fillCheckbox(data.drChecklist.howDidYouMeet === 'Head office lead', "howDidYouMeetHeadOfficeLead");
    fillCheckbox(data.drChecklist.howDidYouMeet === 'Existing subscriber', "howDidYouMeetExistingSubscriber");
    fillCheckbox(data.drChecklist.howDidYouMeet === 'Trade show/Advertisement', "howDidYouMeetTradeShowAdvertisement");
    fillCheckbox(data.drChecklist.howDidYouMeet === 'Through a friend/subscriber', "howDidYouMeetThroughFriendSubscriber");
    fillCheckbox(data.drChecklist.howDidYouMeet === 'Other', "howDidYouMeetOther");

    if (data.drChecklist.howDidYouMeet === 'Trade show/Advertisement') {
        drawText(data.drChecklist.howDidYouMeetDetails, "howDidYouMeetTradeShowAdvertisementDetails");
    }
    if (data.drChecklist.howDidYouMeet === 'Through a friend/subscriber') {
        drawText(data.drChecklist.howDidYouMeetDetails, "howDidYouMeetThroughFriendSubscriberDetails");
    }
    if (data.drChecklist.howDidYouMeet === 'Other') {
        drawText(data.drChecklist.howDidYouMeetDetails, "howDidYouMeetOtherDetails");
    }

    fillCheckbox(data.drChecklist.enrolmentApplicationReviewed, "enrolmentApplicationReviewed");
    fillCheckbox(data.drChecklist.cefiPlanPresentation, "cefiPlanPresentation");
    fillCheckbox(data.drChecklist.enrolmentAppBoxesExplained, "enrolmentAppBoxesExplained");
    fillCheckbox(data.drChecklist.kycDiscussion, "kycDiscussion");
    fillCheckbox(data.drChecklist.planSummaryExplained, "planSummaryExplained");
    fillCheckbox(data.drChecklist.prospectusDelivered, "prospectusDelivered");
    fillCheckbox(data.drChecklist.prospectusAmmendment, "prospectusAmmendment");

    fillCheckbox(data.drChecklist.relationshipDisclosureExplained, "relationshipDisclosureExplained");
    fillCheckbox(data.drChecklist.identificationInspected, "identificationInspected");

    fillCheckbox(data.drChecklist.grantApplicationsExplained, "grantApplicationsExplained");
    fillCheckbox(data.drChecklist.grantLimitsExplained, "grantLimitsExplained");
    fillCheckbox(data.drChecklist.nonResidentRiskDisclosureExplained, "nonResidentRiskDisclosureExplained");
    fillCheckbox(data.drChecklist.thirdPartyFinancialSupportDisclosure, "thirdPartyFinancialSupportDisclosure");
    fillCheckbox(data.drChecklist.frenchEnrolmentApplicationProvided, "frenchEnrolmentApplicationProvided");
    fillCheckbox(data.drChecklist.thirdLanguageAcknowledgement, "thirdLanguageAcknowledgement");
    fillCheckbox(data.drChecklist.escrowAgreementExplained, "escrowAgreementExplained");

    fillCheckbox(data.drChecklist.changesInitialed, "changesInitialed");
    fillCheckbox(data.drChecklist.chequePayableToCET, "chequePayableToCET");
    fillCheckbox(data.drChecklist.dualLicenceDisclosureExplained, "dualLicenceDisclosureExplained");
    fillCheckbox(data.drChecklist.optionalInsuranceFormExplained, "optionalInsuranceFormExplained");

    fillCheckbox(data.drChecklist.cefiTeamsBackgroundUsed, "cefiTeamsBackgroundUsed");
    fillCheckbox(data.drChecklist.identificationScanned, "identificationScanned");
    fillCheckbox(data.drChecklist.identificationRecorded, "identificationRecorded");
    fillCheckbox(data.drChecklist.identificationInspectedRemote, "identificationInspectedRemote");
    fillCheckbox(data.drChecklist.videoConferenceCompleted, "videoConferenceCompleted");

    drawText(data.drChecklist.comments, "comments");

    drawText(nowDate, 'drSignDate');



    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary;
    */

    // Drawing the form
    // TODO implement fields
    // drawText(drSignDate, "drSignDate");
    // drawText(subNames, "subNames");
    // drawText(versionNumber, "versionNumber");
}

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? DRChecklistFr1Labels : DRChecklistEn1Labels;
    const DRRecipientId = POSSIBLE_SIGNERS['Dealing Representative'];
    const subscriberRecipientId = POSSIBLE_SIGNERS['Subscriber'];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS['Joint Subscriber'];
    let signers = [];
    let signHereTabs = [];




    // // check1Siganture
    // signers.push({
    //     [unknownSignerFIXME]: [signatureTab(unknownSignerFIXME, documentId, pageNumber, signatureLabel("check1Siganture", labels))], // TODO MUST check if signer is correct!
    // });


    // // check2Signature
    // signers.push({
    //     [unknownSignerFIXME]: [signatureTab(unknownSignerFIXME, documentId, pageNumber, signatureLabel("check2Signature", labels))], // TODO MUST check if signer is correct!
    // });


    // // check3Signature
    // signers.push({
    //     [unknownSignerFIXME]: [signatureTab(unknownSignerFIXME, documentId, pageNumber, signatureLabel("check3Signature", labels))], // TODO MUST check if signer is correct!
    // });


    // // drSignature
    signers.push({
        [DRRecipientId]: [signatureTab(DRRecipientId, documentId, pageNumber, signatureLabel("drSignatureView", labels))], // TODO MUST check if signer is correct!
    });


    return signers;
}

export default {
    generate,
    signatureDefinitions
}
